window.addEventListener('scroll', function () {
    const header = document.getElementById('custom_header-wrap');
    if (window.scrollY > 100) {
        header.classList.add("customSticky");
    } else {
        header.classList.remove("customSticky");
    }
});